export const mkdirSync = () => {};
export const existsSync = () => false;
export const writeFileSync = () => {};
export const readFileSync = () => '';
export default { mkdirSync, existsSync, writeFileSync, readFileSync };
